import { FC, useMemo } from 'react';

import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

import LatexText from 'components/LatexText/LatexText';

import { resolveOnGoChoiceLabelFontSize } from './resolveOnGoChoiceLabelFontSize';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    wordBreak: 'break-word',
    padding: theme.spacing(0.25, 0.5),
    '& .katex-display': {
      margin: theme.spacing(0.5, 0),
      overflowX: 'auto',
      overflowY: 'hidden',
    },
  },
  mediumSize: {
    fontSize: '0.8125rem',
  },
  smallSize: {
    fontSize: '0.75rem',
  },
  compactSize: {
    fontSize: '0.6875rem',
  },
}));

type OnGoChoiceLabelProps = {
  label: string;
};

const OnGoChoiceLabel: FC<OnGoChoiceLabelProps> = ({ label }) => {
  const classes = useStyles();
  const fontSize = useMemo(() => resolveOnGoChoiceLabelFontSize(label), [label]);

  return (
    <Typography
      className={clsx(classes.root, {
        [classes.mediumSize]: fontSize === 'medium',
        [classes.smallSize]: fontSize === 'small',
        [classes.compactSize]: fontSize === 'compact',
      })}
      component='div'
      variant='body2'
    >
      <LatexText text={label} />
    </Typography>
  );
};

export default OnGoChoiceLabel;
